import(/* webpackMode: "eager" */ "/home/ubuntu/download/695949517683ed0014eb4b27/signaly_trading_platform/src/app/privacy-policy/page.tsx");
